import { cva, VariantProps } from 'class-variance-authority'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

const ImageContainerVariants = cva(
  cn(
    'cursor-pointer overflow-hidden bg-white',
    'flex items-center justify-center',
  ),
  {
    variants: {},
    defaultVariants: {},
  },
)

interface ImageContainerProps
  extends VariantProps<typeof ImageContainerVariants> {
  className?: string
  alt?: string
  src?: string
}

function Component({ alt, className, ...props }: ImageContainerProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className={ImageContainerVariants({ className })}>
          <img
            alt={alt ?? 'Preview'}
            className="h-full w-full object-contain"
            {...props}
          />
        </div>
      </DialogTrigger>

      <DialogContent className="w-fit max-w-[100vw] overflow-hidden border-none p-0 shadow-none">
        <DialogTitle className="hidden">Imagem</DialogTitle>
        <DialogDescription asChild>
          <div className="flex items-center justify-center">
            <img
              alt={alt ?? 'Preview'}
              className="h-[80vh] max-w-[100vw] object-contain md:max-w-[80vw]"
              {...props}
            />
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  )
}
Component.displayName = 'ImageContainer'

export { Component as ImageContainer, ImageContainerVariants }
